import { createContext, useContext, useState } from "react";

const LangContext = createContext({ lang: "it", setLang: () => {}, tr: (it) => it });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("ad_lang") || "it"
  );
  const setLang = (l) => {
    localStorage.setItem("ad_lang", l);
    setLangState(l);
  };
  const tr = (it, en) => (lang === "it" ? it : en);
  return (
    <LangContext.Provider value={{ lang, setLang, tr }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
